import { CSSProperties, useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import TreeGroupDropdown from '@/shared/Tree/components/TreeGroupDropdown'
import { ITreeGroup } from '@/shared/Tree/tree.types.ts'
import { IDashboardGroup } from '@/pages/Dashboards/dashboards.types.ts'
import dashboardGroupsAtom from '@/pages/Dashboards/dashboard.groups.atom.ts'

interface IProps {
  value: IDashboardGroup['id']
  name: string
  onChange: (val: IDashboardGroup['id'], name: string) => void
  title?: string
  wrapperStyle?: CSSProperties
}

const DashboardGroupDropdown = (props: IProps) => {
  const groups = useRecoilValue(dashboardGroupsAtom).items

  const treeGroups: ITreeGroup<IDashboardGroup, number>[] = useMemo(() => {
    if (!groups.length) return []

    return groups.map((g) => ({ id: g.id, parentId: g.parentId, data: g, type: 'none' }))
  }, [groups])

  return (
    <TreeGroupDropdown
      name={props.name}
      wrapperStyle={props.wrapperStyle}
      optionNameGetter={(group: IDashboardGroup) => group.name}
      title={props.title || 'Выберите группу'}
      options={treeGroups as any}
      onSelect={props.onChange}
      selectedOption={props.value}
    />
  )
}

export default DashboardGroupDropdown
